import { render, staticRenderFns } from "./vulnerabilities_assets.vue?vue&type=template&id=d05d5f92&scoped=true"
import script from "./vulnerabilities_assets.vue?vue&type=script&lang=js"
export * from "./vulnerabilities_assets.vue?vue&type=script&lang=js"
import style0 from "./vulnerabilities_assets.vue?vue&type=style&index=0&id=d05d5f92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05d5f92",
  null
  
)

export default component.exports